import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Star, BadgeCheck } from 'lucide-react';

export const ReviewStrip = ({ limit = 3, className = '' }) => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    axios.get('/api/reviews?approved_only=true')
      .then((r) => setReviews((r.data || []).filter((x) => (x.review_text || x.comment) && x.rating >= 4).slice(0, limit)))
      .catch(() => setReviews([]));
  }, [limit]);

  if (!reviews.length) return null;

  return (
    <div data-testid="review-strip" className={`grid gap-3 sm:grid-cols-3 ${className}`}>
      {reviews.map((r) => (
        <figure key={r.id} data-testid={`review-strip-item-${r.id}`} className="rounded-xl border border-white/10 bg-white/[0.03] p-4">
          <div className="flex items-center gap-0.5 mb-2">
            {[...Array(r.rating)].map((_, i) => <Star key={i} size={13} className="text-yellow-400 fill-yellow-400" />)}
          </div>
          <blockquote className="text-sm text-gray-300 leading-relaxed line-clamp-3">"{(r.review_text || r.comment).trim()}"</blockquote>
          <figcaption className="mt-3 flex items-center gap-1.5 text-xs text-gray-400">
            <BadgeCheck size={14} className="text-green-400" />
            <span className="text-white font-semibold">{r.name}</span>
            {r.engineer_name && <span>· with {r.engineer_name}</span>}
          </figcaption>
        </figure>
      ))}
    </div>
  );
};

export default ReviewStrip;
